<template>
<div class="fit">
    <q-btn class="close-panel right top position-absolute" color="grey-8" @click.prevent="closePanel" type="button" icon="close" size="12px" flat dense />
    <b-tabs borderless>
        <b-tab class="p-0">
            <template slot="title">
                <div class="text-negative font-weight-bold pt-1">
                    <q-icon size="1rem" color="red" name="delete" />&nbsp;
                    {{translate('delete_user_confirmation')}}
                </div>
            </template>
            <b-list-group class="list-group-accent">
                <b-list-group-item>
                    <q-item class="p-0">
                        <q-item-section avatar class="p-0">
                            <q-avatar class="ml-2 shadow-2">
                                <img v-if="user.image_link" class="black-and-white" :src="user.image_link">
                                <i v-else class="fas fa-user fa-1x text-primary"></i>
                            </q-avatar>
                        </q-item-section>
                        <q-item-section class="full-height align-self-center pt-2 pb-2">
                            <strong class="text-muted">{{ user.name }}</strong>
                        </q-item-section>
                    </q-item>
                    <q-item class="p-0">
                        <q-item-section avatar class="p-0">
                            <q-avatar class="ml-2 shadow-2">
                                <i class="fas fa-envelope fa-1x text-primary"></i>
                            </q-avatar>
                        </q-item-section>
                        <q-item-section class="full-height align-self-center pt-2 pb-2">
                            <strong class="text-muted">{{ user.email }}</strong>
                        </q-item-section>
                    </q-item>
                    <q-item class="p-0">
                        <q-item-section avatar class="p-0">
                            <q-avatar class="ml-2 shadow-2">
                                <i class="fas fa-user-cog fa-1x text-primary"></i>
                            </q-avatar>
                        </q-item-section>
                        <q-item-section class="full-height align-self-center pt-2 pb-2">
                            <strong class="text-muted">{{ translate(user.user_type) }}</strong>
                        </q-item-section>
                    </q-item>
                </b-list-group-item>
                <b-list-group-item class="text-negative">
                    <q-item class="p-0 text-h6">
                        <q-item-section>
                            <q-item-label line="1">{{translate('deleting_user_confirmation')}}</q-item-label>
                            <q-item-label line="2">{{translate('deleting_user_confirmation_no_undo')}}</q-item-label>
                        </q-item-section>
                    </q-item>
                </b-list-group-item>
                <b-list-group-item>
                    <q-item class="p-0 full-width">
                        <q-item-section side>
                            <q-btn no-caps @click="deleteUser" type="submit" color="negative">
                                <q-icon class="mr-1" size="1rem" name="delete" /> {{translate('proceed_delete')}}
                            </q-btn>
                        </q-item-section>
                        <q-item-section></q-item-section>
                        <q-item-section side>
                            <q-btn no-caps @click.prevent="closePanel" type="button" color="secondary" class="text-dark">
                                <q-icon class="mr-1" size="1rem" name="cancel" /> {{translate('cancel')}}
                            </q-btn>
                        </q-item-section>
                    </q-item>
                </b-list-group-item>
            </b-list-group>
        </b-tab>
    </b-tabs>
</div>
</template>

<script>
import _ from 'lodash'
import jwt_decode from 'jwt-decode'

export default {
    name: 'DeleteUserSecondConfirmation',
    props: ['user'],
    data: function() {
        return {
            deleted: false,
        };
    },
    methods: {
        deleteUser: function () {
            let user_id = this.user.user_id
            var userUrl = baseUrl + 'users/' + user_id
            var headers = {
                'Authorization': 'Bearer ' + this.accessToken(),
            };

            axios.delete(userUrl, {
                    headers: headers
                })
                .then(response => {
                    var key = response.data.key ? '_' + response.data.key : ''
                    var message = 'delete_user_' + response.data.msg + key
                    var translated_message = this.translate(message)
                    if (response.data.status) {
                        this.$toasted.success(translated_message, {
                            duration: this.$toasted_duration
                        })

                        var decoded = jwt_decode(this.accessToken())
                        if (user_id === decoded.identity.user_id) {
                            // Clean local storage and redirect to 'Login'.
                            this.logoutUser()
                        } else {
                            // Redirect to 'Users' after delete.
                            this.$router.push({
                                name: 'Users'
                            }, undefined, () => { 
                                location.href = this.$route.hash 
                            })
                        }
                        // Fix issue from slideout closing panel.
                        document.querySelector('body').classList.remove('slideout-panel-open')
                    } else {
                        this.$toasted.error(translated_message, {
                            duration: this.$toasted_duration
                        })
                    }
                })
                .catch(function (error) {
                    // console.log(error);
                });
        },
        logoutUser: function () {
            localStorage.clear()
            if (this.$appSettings.userNav) {
                this.$appSettings.userNav = []
            }

            // Redirect to 'Login' after logout.
            this.$router.replace({
                name: 'Login'
            }, undefined, () => { 
                location.href = this.$route.hash 
            })
        },
        closePanel() {
            this.$emit('closePanel');
        }
    }
}
</script>
